export default ({ request }) => ({
  reportOrderlistListApi(data = {}) {
    return request({
      url: '/factory/report/orderlist/list',
      method: 'post',
      data,
      timeout: 60 * 1000,
    })
  },
})
